import {
    IonCard,
    IonCardContent,
    IonCol,
    IonIcon,
    IonLabel,
    IonRow,
} from "@ionic/react";
import { alertCircleOutline } from "ionicons/icons";
import React from "react";

interface _Props {
    error: string
    width?: string
}

const ErrorAlert: React.FC<_Props> = ({error, width}) => {
    return (
        <>
            <IonRow className="ion-justify-content-center">
                <IonCol sizeSm="12" sizeMd={width ? width : "8"} className="ion-no-padding">
                    <IonCard color="danger" mode="md">
                        <IonCardContent>
                            <IonIcon icon={alertCircleOutline} />
                            <IonLabel id="errorMsg" className="ion-text-wrap description font-weight-bold">
                                {" " + error}
                            </IonLabel>
                        </IonCardContent>
                    </IonCard>
                </IonCol>
            </IonRow>
        </>
    );
};

export default ErrorAlert;
